import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
export default class Bounds extends createImmutableObjectClass({
  minX: 0,
  minY: 0,
  maxX: 0,
  maxY: 0
}) {
  get width() {
    return this.maxX - this.minX;
  }
  get height() {
    return this.maxY - this.minY;
  }
}